/* RF Experiencia — Repuestos Feñita */
(function () {
  'use strict';
  var RF = window.RF || { template: '' };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var scoped = RF.template === 'index' || RF.template === 'product';
  var CLP = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var store = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  /* ================= 1. Barra de progreso ================= */
  function progressBar() {
    if (!scoped) return;
    var bar = el('div', { class: 'rf-progress', 'aria-hidden': 'true' });
    document.body.appendChild(bar);
    var ticking = false;
    function upd() {
      var h = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ================= 2. Entradas al hacer scroll ================= */
  function reveals() {
    if (!scoped || reduce || !('IntersectionObserver' in window)) return;
    var main = document.querySelector('main') || document.body;
    var groups = main.querySelectorAll('.shopify-section');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rf-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    groups.forEach(function (sec) {
      if (sec.querySelector('.rf-hero3d, .rf-hero, .rf-foot, .rf-brands')) return;
      if (sec.querySelector('.product-information')) return; // la ficha principal no se oculta
      var items = sec.querySelectorAll('h2, h3:not(product-card h3), .text-block > p, product-card, .resource-list__item, .collection-card, [class*="oferta"] article, [class*="beneficio"] li, .product-media-container, img:not(product-card img), .button:not(product-card .button), details');
      var n = 0;
      items.forEach(function (it) {
        if (it.closest('.rf-rv') || it.closest('header') || it.closest('dialog')) return;
        var r = it.getBoundingClientRect();
        if (r.height === 0) return;
        it.classList.add('rf-rv');
        if (it.matches('product-card, .collection-card, .resource-list__item')) it.classList.add('rf-rv--scale');
        it.style.setProperty('--rf-d', Math.min(n, 8) * 75 + 'ms');
        n++;
        io.observe(it);
      });
    });
    // red de seguridad: nada queda oculto
    setTimeout(function () { document.querySelectorAll('.rf-rv:not(.rf-in)').forEach(function (x) { var r = x.getBoundingClientRect(); if (r.top < innerHeight) x.classList.add('rf-in'); }); }, 2500);
  }

  /* ================= 3. Inclinación 3D en tarjetas ================= */
  function tilt(card, max) {
    if (card.__rfTilt) return; card.__rfTilt = 1;
    card.classList.add('rf-tilt');
    if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
    var light = el('span', { class: 'rf-tilt__light', 'aria-hidden': 'true' });
    card.appendChild(light);
    var raf = 0;
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.classList.add('rf-tilting');
        card.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max).toFixed(2) + 'deg) translateZ(0) translateY(-4px)';
        card.style.setProperty('--rf-lx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--rf-ly', (y * 100).toFixed(1) + '%');
      });
    });
    card.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      card.classList.remove('rf-tilting');
      card.style.transform = '';
    });
  }
  function tilts() {
    if (!scoped || reduce || !finePointer) return;
    var apply = function (root) {
      root.querySelectorAll('product-card, .collection-card, .resource-list__item > a, [class*="oferta"] article').forEach(function (c) { tilt(c, 8); });
    };
    apply(document);
    new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) apply(n); }); }); })
      .observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }

  /* ================= 4. Botones magnéticos ================= */
  function magnetic() {
    if (!scoped || reduce || !finePointer) return;
    document.querySelectorAll('.rf-btn, .add-to-cart-button, .shopify-payment-button__button, main .button').forEach(function (b) {
      if (b.__rfMag) return; b.__rfMag = 1;
      b.classList.add('rf-mag');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.transform = 'translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 5).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ================= 5. Contadores ================= */
  function counters() {
    var nodes = document.querySelectorAll('[data-rf-count]');
    if (!nodes.length) return;
    var run = function (n) {
      var to = parseInt(n.getAttribute('data-rf-count'), 10) || 0, pre = n.getAttribute('data-rf-prefix') || '';
      if (reduce || !to) { n.textContent = pre + to.toLocaleString('es-CL'); return; }
      var t0 = performance.now(), dur = 1400;
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
        n.textContent = pre + Math.round(to * e).toLocaleString('es-CL');
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    };
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ================= 6. Portada 3D (Three.js) ================= */
  function hero3d() {
    var hero = document.querySelector('[data-rf-hero3d]');
    if (!hero) return;
    var box = hero.querySelector('[data-rf-canvas]');
    var range = hero.querySelector('[data-rf-valve]');
    var out = hero.querySelector('[data-rf-valve-out]');
    var level = 0, target = 0, userTouched = false;
    function label(v) { return v <= 0 ? 'Apagado' : v < 34 ? 'Mínimo' : v < 70 ? 'Medio' : 'Máximo'; }
    function setVal(v) {
      range.value = v; range.style.setProperty('--rf-v', v + '%');
      out.textContent = label(v) + (v > 0 ? ' · ' + v + '%' : '');
      target = v / 100;
    }
    range.addEventListener('input', function () { userTouched = true; setVal(+range.value); });
    setVal(0);

    var gl = document.createElement('canvas').getContext('webgl2') || document.createElement('canvas').getContext('webgl');
    if (!gl) return;

    var started = false;
    function loadThree() {
      return new Promise(function (res, rej) {
        if (window.__rfThree) return res(window.__rfThree);
        addEventListener('rf-three', function () { res(window.__rfThree); }, { once: true });
        var s = document.createElement('script'); s.type = 'module';
        s.textContent = 'import * as T from "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js"; window.__rfThree = T; dispatchEvent(new Event("rf-three"));';
        s.onerror = rej; document.head.appendChild(s);
      });
    }
    var start = function () {
      if (started) return; started = true;
      loadThree().then(function (THREE) {
        build(THREE);
      }).catch(function () {});
    };
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { start(); } }, { rootMargin: '200px' });
    io.observe(box);

    function build(THREE) {
      var W = box.clientWidth, H = box.clientHeight;
      var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
      renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 1.75));
      renderer.setSize(W, H, false);
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.05;
      box.appendChild(renderer.domElement);

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(32, W / H, 0.1, 100);
      camera.position.set(0, 6.2, 10.2);
      camera.lookAt(0, 0.2, 0);

      /* Entorno propio (estudio) para reflejos metálicos */
      var pm = new THREE.PMREMGenerator(renderer);
      var env = new THREE.Scene();
      env.background = new THREE.Color(0x0c111c);
      var panel = function (c, i, w, h, x, y, z, ry, rx) {
        var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(c).multiplyScalar(i), side: THREE.DoubleSide }));
        m.position.set(x, y, z); m.rotation.y = ry || 0; m.rotation.x = rx || 0; env.add(m);
      };
      panel(0xffffff, 6, 8, 3, 0, 7, 0, 0, Math.PI / 2);
      panel(0xffe2b8, 3, 3, 6, -7, 1, 0, Math.PI / 2);
      panel(0xbfd8ff, 2.5, 3, 6, 7, 1, 0, -Math.PI / 2);
      panel(0xffffff, 1.4, 10, 2, 0, 1.5, -7, 0);
      scene.environment = pm.fromScene(env, 0.035).texture;

      var iron = new THREE.MeshStandardMaterial({ color: 0x1c1f26, metalness: 0.75, roughness: 0.48 });
      var ironDark = new THREE.MeshStandardMaterial({ color: 0x121419, metalness: 0.6, roughness: 0.62 });
      var brass = new THREE.MeshStandardMaterial({ color: 0xd4a84f, metalness: 1, roughness: 0.24 });
      var steel = new THREE.MeshStandardMaterial({ color: 0xb9c0cb, metalness: 1, roughness: 0.3 });
      var red = new THREE.MeshStandardMaterial({ color: 0xb3121f, metalness: 0.2, roughness: 0.38 });

      var rig = new THREE.Group(); scene.add(rig);
      var burner = new THREE.Group(); rig.add(burner);

      /* Anillos de fierro fundido + rayos */
      var ringOuter = new THREE.Mesh(new THREE.TorusGeometry(2.25, 0.2, 24, 120), iron); ringOuter.rotation.x = Math.PI / 2; burner.add(ringOuter);
      var ringInner = new THREE.Mesh(new THREE.TorusGeometry(1.15, 0.18, 24, 90), iron); ringInner.rotation.x = Math.PI / 2; burner.add(ringInner);
      var hub = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.5, 0.42, 40), ironDark); burner.add(hub);
      for (var s = 0; s < 3; s++) {
        var a = s / 3 * Math.PI * 2 + Math.PI / 6;
        var spoke = new THREE.Mesh(new THREE.BoxGeometry(0.22, 0.2, 2.2), iron);
        spoke.position.set(Math.sin(a) * 1.35, 0, Math.cos(a) * 1.35); spoke.rotation.y = a; burner.add(spoke);
        var foot = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.14, 0.7, 16), ironDark);
        foot.position.set(Math.sin(a) * 2.25, -0.42, Math.cos(a) * 2.25); burner.add(foot);
      }

      /* Entrada de gas, válvula de bronce y perilla roja */
      var pipe = new THREE.Mesh(new THREE.CylinderGeometry(0.17, 0.17, 2.6, 28), steel);
      pipe.rotation.z = Math.PI / 2; pipe.position.set(3.4, -0.08, 0); burner.add(pipe);
      var venturi = new THREE.Mesh(new THREE.CylinderGeometry(0.26, 0.3, 0.5, 6), brass);
      venturi.rotation.z = Math.PI / 2; venturi.position.set(2.45, -0.08, 0); burner.add(venturi);
      var valve = new THREE.Mesh(new THREE.CylinderGeometry(0.34, 0.34, 0.62, 6), brass);
      valve.position.set(4.15, -0.08, 0); burner.add(valve);
      var nut = new THREE.Mesh(new THREE.CylinderGeometry(0.22, 0.22, 0.5, 6), brass);
      nut.rotation.z = Math.PI / 2; nut.position.set(4.75, -0.08, 0); burner.add(nut);
      var knobPivot = new THREE.Group(); knobPivot.position.set(4.15, 0.25, 0); burner.add(knobPivot);
      var stem = new THREE.Mesh(new THREE.CylinderGeometry(0.06, 0.06, 0.3, 12), steel); stem.position.y = 0.12; knobPivot.add(stem);
      var lever = new THREE.Mesh(new THREE.BoxGeometry(1.1, 0.12, 0.22), red); lever.position.set(0.42, 0.3, 0); knobPivot.add(lever);

      /* 23 inyectores de bronce: 8 interiores + 15 exteriores */
      var ports = [];
      var injGeo = new THREE.CylinderGeometry(0.07, 0.1, 0.26, 14);
      var tipGeo = new THREE.CylinderGeometry(0.11, 0.11, 0.08, 6);
      function ring(n, r, off) {
        for (var i = 0; i < n; i++) {
          var ang = i / n * Math.PI * 2 + off;
          var g = new THREE.Group();
          g.position.set(Math.cos(ang) * r, 0.2, Math.sin(ang) * r);
          var inj = new THREE.Mesh(injGeo, brass); inj.position.y = 0.12; g.add(inj);
          var tip = new THREE.Mesh(tipGeo, brass); tip.position.y = 0.25; g.add(tip);
          g.rotation.z = -Math.cos(ang) * 0.22; g.rotation.x = Math.sin(ang) * 0.22;
          burner.add(g);
          ports.push({ g: g, ang: ang, r: r });
        }
      }
      ring(8, 1.15, 0.2); ring(15, 2.25, 0);

      /* Llamas: shader aditivo por inyector */
      var flameMat = new THREE.ShaderMaterial({
        transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, side: THREE.DoubleSide,
        uniforms: { uTime: { value: 0 } },
        vertexShader: [
          'attribute float aSeed; attribute float aLevel; varying vec2 vUv; varying float vLevel; varying float vSeed; uniform float uTime;',
          'void main(){ vUv = uv; vLevel = aLevel; vSeed = aSeed;',
          ' vec3 p = position; float h = uv.y; float f = sin(uTime*14.0 + aSeed*31.0 + h*6.0)*0.06*h;',
          ' p.x += f; p.y *= mix(0.0, 1.0, aLevel) * (0.9 + 0.12*sin(uTime*9.0 + aSeed*17.0));',
          ' vec4 mv = modelViewMatrix * vec4(p,1.0); gl_Position = projectionMatrix * mv; }'
        ].join('\n'),
        fragmentShader: [
          'varying vec2 vUv; varying float vLevel; varying float vSeed;',
          'void main(){ float x = abs(vUv.x - 0.5) * 2.0; float y = vUv.y;',
          ' float body = smoothstep(1.0, 0.0, x / max(0.05, (1.0 - y*0.85))) * smoothstep(1.0, 0.55, y);',
          ' float core = smoothstep(0.55, 0.0, x / max(0.05, (1.0 - y))) * smoothstep(0.6, 0.0, y);',
          ' vec3 blue = vec3(0.16, 0.42, 1.0); vec3 cyan = vec3(0.55, 0.85, 1.0); vec3 tipc = vec3(1.0, 0.62, 0.25);',
          ' vec3 c = mix(blue, cyan, core) + tipc * smoothstep(0.75, 1.0, y) * smoothstep(0.6, 1.0, vLevel) * 0.6;',
          ' float a = (body * 0.8 + core * 0.9) * smoothstep(0.0, 0.08, vLevel);',
          ' gl_FragColor = vec4(c * a * 1.6, a); }'
        ].join('\n')
      });
      var flames = [];
      ports.forEach(function (p, i) {
        var geo = new THREE.PlaneGeometry(0.38, 0.85, 1, 8); geo.translate(0, 0.5, 0);
        var seed = new Float32Array(geo.attributes.position.count).fill(Math.random());
        var lev = new Float32Array(geo.attributes.position.count).fill(0);
        geo.setAttribute('aSeed', new THREE.BufferAttribute(seed, 1));
        geo.setAttribute('aLevel', new THREE.BufferAttribute(lev, 1));
        var m1 = new THREE.Mesh(geo, flameMat); m1.position.y = 0.29;
        var m2 = new THREE.Mesh(geo, flameMat); m2.position.y = 0.29; m2.rotation.y = Math.PI / 2;
        p.g.add(m1); p.g.add(m2);
        flames.push({ geo: geo, lev: lev, port: p, cur: 0, delay: (i < 8 ? i / 8 : (i - 8) / 15) * 0.55 + (i < 8 ? 0 : 0.25) });
      });

      /* Brillo cálido y piso */
      var glow = new THREE.PointLight(0x5aa2ff, 0, 9, 1.6); glow.position.set(0, 1.2, 0); scene.add(glow);
      var key = new THREE.DirectionalLight(0xffffff, 1.4); key.position.set(4, 8, 5); scene.add(key);
      scene.add(new THREE.HemisphereLight(0x9fb4d8, 0x0a0e17, 0.45));
      var floor = new THREE.Mesh(new THREE.CircleGeometry(4.2, 64), new THREE.MeshStandardMaterial({ color: 0x141b2b, metalness: 0.2, roughness: 0.9 }));
      floor.rotation.x = -Math.PI / 2; floor.position.y = -0.78; scene.add(floor);
      var halo = new THREE.Mesh(new THREE.RingGeometry(2.2, 2.6, 96), new THREE.MeshBasicMaterial({ color: 0x3b82f6, transparent: true, opacity: 0, blending: THREE.AdditiveBlending, depthWrite: false }));
      halo.rotation.x = -Math.PI / 2; halo.position.y = -0.76; scene.add(halo);

      /* Chispas */
      var SP = 90, spGeo = new THREE.BufferGeometry(), spPos = new Float32Array(SP * 3), spLife = [];
      for (var k = 0; k < SP; k++) { spLife.push({ t: Math.random(), p: ports[k % ports.length] }); }
      spGeo.setAttribute('position', new THREE.BufferAttribute(spPos, 3));
      var sparks = new THREE.Points(spGeo, new THREE.PointsMaterial({ color: 0x9fd0ff, size: 0.05, transparent: true, opacity: 0, blending: THREE.AdditiveBlending, depthWrite: false }));
      scene.add(sparks);

      rig.position.x = -1.5; rig.rotation.x = 0.05;

      /* Interacción: arrastrar para girar */
      var yaw = -0.5, pitch = 0, vy = 0, drag = null;
      box.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, y: e.clientY, yaw: yaw, pitch: pitch }; box.setPointerCapture(e.pointerId); box.classList.add('rf-dragged'); });
      box.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) > Math.abs(dy) || e.pointerType === 'mouse') {
          yaw = drag.yaw + dx * 0.008; pitch = Math.max(-0.35, Math.min(0.35, drag.pitch + dy * 0.004)); vy = dx * 0.00035;
        }
      });
      var end = function () { drag = null; };
      box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end);
      var mx = 0, my = 0;
      if (finePointer) hero.addEventListener('pointermove', function (e) { var r = hero.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5; });

      new ResizeObserver(function () {
        W = box.clientWidth; H = box.clientHeight; if (!W || !H) return;
        renderer.setSize(W, H, false); camera.aspect = W / H;
        camera.position.z = W / H < 1.05 ? 11.2 : 10.2; camera.updateProjectionMatrix();
        rig.position.x = -1.5;
      }).observe(box);

      var visible = true;
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) loop(); }).observe(box);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) loop(); });

      var clock = new THREE.Clock(), running = false, ignitedAt = -1;
      function loop() { if (running) return; running = true; requestAnimationFrame(frame); }
      function frame() {
        if (!visible || document.hidden) { running = false; return; }
        var dt = Math.min(0.05, clock.getDelta()), t = clock.elapsedTime;
        level += (target - level) * Math.min(1, dt * 4);
        if (target > 0 && ignitedAt < 0) ignitedAt = t;
        if (target === 0) ignitedAt = -1;
        flameMat.uniforms.uTime.value = t;

        flames.forEach(function (f) {
          var on = ignitedAt >= 0 ? Math.min(1, Math.max(0, (t - ignitedAt - f.delay) * 6)) : 0;
          var want = level * on;
          f.cur += (want - f.cur) * Math.min(1, dt * 10);
          f.lev.fill(f.cur); f.geo.attributes.aLevel.needsUpdate = true;
          var s = 0.55 + f.cur * 0.75; f.port.g.children[2].scale.set(1, s, 1); f.port.g.children[3].scale.set(1, s, 1);
        });
        glow.intensity = level * (26 + Math.sin(t * 13) * 2.5);
        halo.material.opacity = level * 0.22;
        knobPivot.rotation.y = -level * Math.PI / 2;

        var pos = spGeo.attributes.position.array;
        for (var k = 0; k < SP; k++) {
          var L = spLife[k]; L.t += dt * (0.6 + level * 1.2);
          if (L.t > 1) { L.t = 0; L.p = ports[(Math.random() * ports.length) | 0]; }
          var wp = new THREE.Vector3(); L.p.g.getWorldPosition(wp);
          pos[k * 3] = wp.x + Math.sin(k * 12.9 + t) * 0.12 * L.t;
          pos[k * 3 + 1] = wp.y + 0.45 + L.t * 1.6 * level;
          pos[k * 3 + 2] = wp.z + Math.cos(k * 7.1 + t) * 0.12 * L.t;
        }
        spGeo.attributes.position.needsUpdate = true;
        sparks.material.opacity = level * 0.85;

        if (!drag && !reduce) { yaw += 0.0026 + vy; vy *= 0.95; }
        rig.rotation.y += (yaw + mx * 0.25 - rig.rotation.y) * 0.08;
        rig.rotation.x += (0.05 + pitch + my * 0.1 - rig.rotation.x) * 0.08;
        var hr = hero.getBoundingClientRect();
        var sp = Math.max(0, Math.min(1, -hr.top / Math.max(1, hr.height)));
        camera.position.y = 6.2 - sp * 2.2; camera.lookAt(0, 0.2, 0);

        renderer.render(scene, camera);
        requestAnimationFrame(frame);
      }
      box.classList.add('rf-ready');
      loop();
      // Encendido automático (la llave se puede mover cuando quieras)
      setTimeout(function () {
        if (userTouched) return;
        var v = 0, goal = 68;
        (function rampUp() { if (userTouched) return; v = Math.min(goal, v + 2); setVal(v); if (v < goal) setTimeout(rampUp, 16); })();
      }, reduce ? 0 : 900);
    }
  }

  /* ================= 7. Ficha de producto ================= */
  var HOLIDAYS = ['2026-01-01', '2026-04-03', '2026-04-04', '2026-05-01', '2026-05-21', '2026-06-21', '2026-06-29', '2026-07-16', '2026-08-15', '2026-09-18', '2026-09-19', '2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-03-26', '2027-03-27', '2027-05-01', '2027-05-21', '2027-06-21', '2027-06-28', '2027-07-16', '2027-08-15', '2027-09-17', '2027-09-18', '2027-09-19', '2027-10-11', '2027-10-31', '2027-11-01', '2027-12-08', '2027-12-25'];
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) < 0; }
  function addBiz(from, n) { var d = new Date(from); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' }).replace('.', ''); }

  function eta() {
    if (RF.template !== 'product' || !RF.ci) return;
    var anchor = document.querySelector('.essential-estimated-delivery-block') || document.querySelector('.product-information .product-form-buttons') || document.querySelector('.product-information product-form-component, .product-information form[action*="/cart/add"]');
    if (!anchor) return;
    var now = new Date(), d0 = addBiz(now, 1), d2 = addBiz(now, 2), d3 = addBiz(now, 3), d5 = addBiz(now, 5);
    var price = (RF.price || 0) / 100;
    var free = price >= 100000;
    var ico = {
      cart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 4h2l2.4 11h10.8L21 7H7" stroke="currentColor" stroke-width="2"/><circle cx="9" cy="20" r="1.6" fill="currentColor"/><circle cx="18" cy="20" r="1.6" fill="currentColor"/></svg>',
      box: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z M3 7.5 12 12l9-4.5M12 12v9" stroke="currentColor" stroke-width="1.8"/></svg>',
      truck: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 6h12v10H2zM14 9h4l4 4v3h-8z" stroke="currentColor" stroke-width="1.8"/><circle cx="6" cy="18" r="2" fill="currentColor"/><circle cx="18" cy="18" r="2" fill="currentColor"/></svg>',
      home: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 11 12 4l9 7v9h-6v-6H9v6H3z" stroke="currentColor" stroke-width="1.8"/></svg>',
      ok: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7" stroke="currentColor" stroke-width="2.4"/></svg>',
      info: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 11v6M12 7.5v.5" stroke="currentColor" stroke-width="2.2"/></svg>'
    };
    var steps = [['Compras', 'hoy', ico.cart], ['Preparamos', fmt(d0), ico.box], ['En camino', fmt(d2), ico.truck.replace('22', '16').replace('22', '16')], ['Llega', d3.getDate() + '–' + fmt(d5).replace(/^\S+\s/, ''), ico.home]];
    var html =
      '<div class="rf-eta__tabs" role="tablist" aria-label="Destino del envío">' +
      '<span class="rf-eta__pill" aria-hidden="true"></span>' +
      '<button type="button" class="rf-eta__tab" role="tab" id="rfEtaT1" aria-controls="rfEtaP1" aria-selected="true">Región Metropolitana</button>' +
      '<button type="button" class="rf-eta__tab" role="tab" id="rfEtaT2" aria-controls="rfEtaP2" aria-selected="false" tabindex="-1">Otras regiones</button></div>' +
      '<div class="rf-eta__body">' +
      '<div class="rf-eta__panel" role="tabpanel" id="rfEtaP1" aria-labelledby="rfEtaT1">' +
      '<p class="rf-eta__head">Llega a tu domicilio entre el <strong>' + fmt(d3) + '</strong> y el <strong>' + fmt(d5) + '</strong> (3 a 5 días hábiles).</p>' +
      '<div class="rf-eta__track" aria-hidden="true"><div class="rf-eta__line"><i></i></div><span class="rf-eta__truck">' + ico.truck + '</span>' +
      steps.map(function (s, i) { return '<div class="rf-eta__step" style="--s:' + i + '"><span class="rf-eta__dot">' + s[2] + '</span><b>' + s[0] + '</b><small>' + s[1] + '</small></div>'; }).join('') + '</div>' +
      (free
        ? '<p class="rf-eta__note">' + ico.ok + '<span><strong>Envío gratis en la RM.</strong> Este producto supera los $100.000.</span></p>'
        : '<p class="rf-eta__note">' + ico.ok + '<span>Envío RM <strong>$4.990</strong>. Gratis desde <strong>$100.000</strong> en productos Comercial e Industrial; te faltan <strong>' + CLP(100000 - price) + '</strong>.</span></p>') +
      '</div>' +
      '<div class="rf-eta__panel" role="tabpanel" id="rfEtaP2" aria-labelledby="rfEtaT2" hidden>' +
      '<p class="rf-eta__head">Despachamos a <strong>todo Chile</strong>. El flete a regiones se cotiza según peso, medidas y destino.</p>' +
      '<p class="rf-eta__note rf-eta__note--warn">' + ico.info + '<span>Al comprar, el envío aparece en $0. Después te contactamos con el valor del flete y el plazo antes de despachar.</span></p>' +
      '</div>' +
      (RF.dd ? '' : '') +
      '</div>';
    var card = el('div', { class: 'rf-eta', 'data-mode': 'rm' }, html);
    anchor.parentNode.insertBefore(card, anchor.nextSibling);

    var tabs = card.querySelectorAll('.rf-eta__tab'), panels = card.querySelectorAll('.rf-eta__panel');
    function sel(i) {
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      card.setAttribute('data-mode', i ? 'reg' : 'rm');
      if (!i) { card.classList.remove('rf-go'); void card.offsetWidth; card.classList.add('rf-go'); }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(i); });
      t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = i ? 0 : 1; sel(n); tabs[n].focus(); } });
    });
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { card.classList.add('rf-go'); io.disconnect(); } }, { threshold: 0.4 });
    io.observe(card);
  }

  function shipBlock() {
    if (RF.template !== 'product') return;
    document.querySelectorAll('details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s || !/^\s*Env[ií]os/i.test(s.textContent)) return;
      d.classList.add('rf-ship');
      if (reduce || !d.animate) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        var body = [].slice.call(d.children).filter(function (c) { return c !== s; });
        if (d.open) {
          var h = d.offsetHeight;
          var a = d.animate([{ height: h + 'px' }, { height: s.offsetHeight + 'px' }], { duration: 320, easing: 'cubic-bezier(.2,.7,.1,1)' });
          a.onfinish = function () { d.open = false; };
        } else {
          var h0 = d.offsetHeight; d.open = true; var h1 = d.offsetHeight;
          d.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 380, easing: 'cubic-bezier(.2,.7,.1,1)' });
          body.forEach(function (b, i) { b.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 400, delay: 80 + i * 60, fill: 'both', easing: 'ease-out' }); });
        }
      });
    });
  }

  /* ================= 8. Chispa — asistente de Repuestos Feñita ================= */
  var LS = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  var BOT_SVG = '<svg viewBox="0 0 32 32" width="100%" height="100%" aria-hidden="true"><line x1="16" y1="3.5" x2="16" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="16" cy="3.4" r="2.2" fill="#f0b76b"/><rect x="5" y="8" width="22" height="17" rx="7" fill="currentColor"/><rect x="2.5" y="13.5" width="3" height="6" rx="1.5" fill="currentColor"/><rect x="26.5" y="13.5" width="3" height="6" rx="1.5" fill="currentColor"/><rect x="8.5" y="11.5" width="15" height="9" rx="4.5" fill="#111827"/><circle cx="12.8" cy="16" r="1.9" fill="#7fd1ff"/><circle cx="19.2" cy="16" r="1.9" fill="#7fd1ff"/><path d="M13 22.3h6" stroke="#111827" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var STOP = ('a al algo algun alguna algunas algunos ante antes como con contra cual cuales cuando de del desde donde dos el ella ellas ellos en entre era es esa ese eso esta este esto estos esas esos estan esta hay la las le les lo los mas me mi mis mucho muy necesito necesita nos o otra otro para pero poco por porque que quiero quisiera queria se ser si sin sobre su sus tambien tengo tiene tienen todo tu tus un una uno unos unas y ya yo hola buenas buenos dias tardes noches busco buscando favor podrian podria puedo puede pueden ayuda ayudar comprar compro precio precios cuanto cuesta cuestan vale valen tienes tienen venden vende hay alguno algo me le gustaria saber oye amigo hola gracias porfa porfavor sirve sirva servir para modelo marca equipo tipo repuesto repuestos pieza piezas').split(' ');
  var TYPES = ['calefont', 'cocina', 'encimera', 'anafe', 'horno', 'lavadora', 'secadora', 'licuadora', 'estufa', 'refrigerador', 'microondas', 'campana', 'olla', 'freidora', 'batidora', 'hervidor', 'cafetera', 'arrocera', 'sandwichera', 'caldera', 'lavavajillas'];
  var CTX = ['gastronomico', 'industrial', 'kit'];
  var IDF = {};
  var SYN = [
    [/calef|calent(ador)? de agua|calefon|calefo/, ['calefont']],
    [/se apaga|se corta|no queda encendid|se me apaga/, ['termocupla']],
    [/no (enciende|prende|da chispa)|sin chispa|no hace chispa|encendido|chispero|piezo/, ['bujia', 'encendido']],
    [/fuga|pierde gas|olor a gas|huele a gas/, ['llave', 'flexible', 'fitting']],
    [/mangue?ra|flexible/, ['flexible']],
    [/restaurant|restoran|casino|cocina industrial|gastronom|cocineria|food ?truck|cafeteria|negocio/, ['gastronomico', 'industrial']],
    [/panaderi|pasteleri|amasa/, ['horno', 'batidora']],
    [/fog(o|ó)n|quemador|platos?\b/, ['quemador']],
    [/llave de paso|valvula/, ['llave', 'valvula']],
    [/conector|fitting|niple|terminal|copla|\btee\b|codo|hilo|bronce/, ['fitting', 'bronce']],
    [/licuadora|juguera|vaso|cuchilla|aspas/, ['licuadora']],
    [/lavadora|secadora|lavarropa/, ['lavadora']],
    [/membrana|diafragma|no calienta|agua fria|agua tibia/, ['membrana', 'kit']],
    [/olla|sart[eé]n|cacerola/, ['olla']],
    [/olla a presion|olla presion|empaquetadura|valvula de olla/, ['presion']],
    [/freidora/, ['freidora']],
    [/plancha|griddle|churrasquera/, ['plancha']],
    [/acero inox|inoxidable|deposito|\bgn\b|bandeja/, ['deposito']],
    [/estufa|parafina|kerosene/, ['estufa']],
    [/perilla|manilla|boton/, ['perilla']],
    [/inyector|chicler|gicleur/, ['inyector']],
    [/termostato/, ['termostato']],
    [/regulador/, ['regulador']]
  ];
  var DIAG = [
    [/calef.*(se apaga|se corta)|(se apaga|se corta).*calef/, 'Cuando un calefont se apaga a los pocos segundos, lo más común es la termocupla o el sensor de llama. Si además el agua sale tibia, revisa la membrana.'],
    [/no (enciende|prende|da chispa)|sin chispa|no hace chispa/, 'Si no hay chispa, normalmente es la bujía de encendido o su cable. Si hay chispa pero no prende, revisa el paso de gas y el inyector.'],
    [/llama amarilla|llama naranja|hollin|tizna/, 'Una llama amarilla suele indicar un inyector sucio o de medida incorrecta, o falta de aire en el quemador.'],
    [/no calienta|agua fria|agua tibia/, 'Si el calefont enciende pero no calienta bien, revisa el kit de membrana y el estado del serpentín.'],
    [/fuga|olor a gas|huele a gas/, 'Si sientes olor a gas, cierra la llave de paso, ventila y no enciendas artefactos. Luego revisa flexibles, llaves y fittings. Ante cualquier duda, llama a un técnico certificado SEC.']
  ];
  var FAQ = [
    { k: /despacho|envio|enviar|envian|flete|llega|cuanto demora|demora|tarda|region|regiones|santiago|domicilio|blue ?express/, a: function () {
      return '<p><strong>Envíos</strong></p><p>• Repuestos y hogar: Blue Express a todo Chile; el valor se calcula en el pago según peso y comuna.</p><p>• Comercial e industrial: Región Metropolitana <strong>$4.990</strong>, gratis sobre <strong>$100.000</strong> (3 a 5 días hábiles). A regiones el flete se cotiza después de la compra.</p>';
    }, chips: ['¿Puedo retirar en tienda?', '¿Cuál es el horario?'] },
    { k: /retir|sucursal|local|tienda fisica|direccion|donde estan|donde quedan|ubicacion|mapa/, a: function () {
      return '<p><strong>Retiro y sucursales</strong></p><p>• San Pablo 1078, local comercial, Santiago.</p><p>• General Mackenna 1044, local comercial, Santiago.</p><p>Elige “Retiro en tienda” al pagar. Algunos equipos industriales se despachan directo desde bodega y no tienen retiro; lo verás en cada ficha.</p>';
    }, chips: ['¿Cuál es el horario?', 'Ver mapa'] },
    { k: /horario|atienden|abren|cierran|abierto|domingo|sabado/, a: function () {
      return '<p>Atendemos <strong>lunes a viernes de 9:00 a 19:00</strong> y <strong>sábados de 9:00 a 17:00</strong>. Domingo cerrado.</p>';
    }, chips: ['¿Dónde están?', 'Hablar por WhatsApp'] },
    { k: /pago|pagar|webpay|tarjeta|cuotas|transferencia|debito|credito|redcompra/, a: function () {
      return '<p>Pagas con <strong>Webpay Plus</strong>: tarjetas de crédito (con cuotas según tu banco), débito y prepago.</p>';
    }, chips: ['¿Entregan boleta o factura?', '¿Cuánto cuesta el envío?'] },
    { k: /boleta|factura|rut|razon social|giro|documento|tributari/, a: function () {
      return '<p>Emitimos <strong>boleta o factura electrónica</strong>. Antes de pagar te preguntamos cuál necesitas; si eliges factura, ingresas RUT, razón social, giro y dirección, y te llega al correo de facturación.</p>';
    }, chips: ['¿Cómo pago?', 'Buscar un repuesto'] },
    { k: /devoluci|devolver|cambio|garantia|falla de fabrica|reembolso/, a: function () {
      return '<p>Revisa nuestra <a href="/policies/refund-policy">política de cambios y devoluciones</a>. Si tienes un caso puntual, escríbenos con tu número de pedido y lo vemos contigo.</p>';
    }, chips: ['Hablar por WhatsApp', 'Buscar un repuesto'] },
    { k: /telefono|whatsapp|contacto|correo|email|llamar|hablar con|humano|persona|vendedor/, a: function () {
      return '<p>Escríbenos por <a href="https://wa.me/' + RF.wa + '" target="_blank" rel="noopener">WhatsApp +56 9 3888 0493</a> o a <a href="mailto:repuestosfenita@gmail.com">repuestosfenita@gmail.com</a>. Respondemos en horario de atención.</p>';
    }, chips: ['¿Cuál es el horario?'] },
    { k: /instala|instalacion|tecnico|reparan|arreglan/, a: function () {
      return '<p>Vendemos los repuestos y te ayudamos a elegir la pieza correcta. Para instalaciones de gas te recomendamos un técnico con certificación SEC. Si quieres, te orientamos por WhatsApp.</p>';
    }, chips: ['Hablar por WhatsApp', 'Buscar un repuesto'] },
    { k: /pedido|orden|seguimiento|tracking|mi compra|no ha llegado|no me llega/, a: function () {
      return '<p>Para revisar tu pedido, escríbenos por <a href="https://wa.me/' + RF.wa + '?text=' + encodeURIComponent('Hola, quiero consultar por mi pedido N°') + '" target="_blank" rel="noopener">WhatsApp</a> con tu número de pedido (está en el correo de confirmación).</p>';
    }, chips: ['¿Cuánto demora el envío?'] }
  ];

  var CAT = null, VOCAB = null, BRANDS = [];
  function stem(w) { return w.length > 4 ? w.replace(/(es|s)$/, '') : w; }
  function tokens(s) { return norm(s).replace(/[^a-z0-9ñ\s]/g, ' ').split(/\s+/).filter(Boolean); }
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 1; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      var c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  function loadCatalog() {
    if (CAT) return Promise.resolve(CAT);
    var cached = LS.get('rfChispaCat');
    if (cached && cached.t > Date.now() - 6 * 3600 * 1000 && cached.p && cached.p.length) { buildIndex(cached.p); return Promise.resolve(CAT); }
    var all = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        var ps = j.products || [];
        ps.forEach(function (p) {
          var v = p.variants && p.variants[0] || {};
          var avail = (p.variants || []).some(function (x) { return x.available; });
          all.push({ i: p.id, t: p.title, h: p.handle, p: parseFloat(v.price) || 0, c: parseFloat(v.compare_at_price) || 0, v: v.id, a: avail,
            img: p.images && p.images[0] ? p.images[0].src : '', ty: p.product_type || '', tg: (p.tags || []).join(' '), vd: p.vendor || '',
            b: String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 400) });
        });
        if (ps.length === 250 && n < 6) return page(n + 1);
      });
    }
    return page(1).then(function () { LS.set('rfChispaCat', { t: Date.now(), p: all }); buildIndex(all); return CAT; })
      .catch(function () { buildIndex(all); return CAT; });
  }
  function buildIndex(list) {
    CAT = list.map(function (p) {
      return { d: p, ti: ' ' + tokens(p.t).map(stem).join(' ') + ' ', me: ' ' + tokens(p.ty + ' ' + p.tg).map(stem).join(' ') + ' ', vd: norm(p.vd), bo: ' ' + tokens(p.b).map(stem).join(' ') + ' ' };
    });
    VOCAB = {}; IDF = {};
    var df = {};
    CAT.forEach(function (x) { var seen = {}; (x.ti + x.me).split(' ').forEach(function (w) { if (w && !seen[w]) { seen[w] = 1; df[w] = (df[w] || 0) + 1; } }); });
    var N = CAT.length || 1;
    Object.keys(df).forEach(function (w) { IDF[w] = Math.max(.35, Math.log(1 + N / (1 + df[w])) / 2.2); });
    var bset = {};
    list.forEach(function (p) {
      tokens(p.t + ' ' + p.ty + ' ' + p.tg + ' ' + p.vd).forEach(function (w) { if (w.length >= 3 && !/^\d+$/.test(w)) VOCAB[stem(w)] = 1; });
      var vd = norm(p.vd).trim(); if (vd && !/feñita|fenita|generico|universal/.test(vd)) bset[vd] = 1;
    });
    TYPES.forEach(function (w) { VOCAB[w] = 1; });
    BRANDS = Object.keys(bset).concat(['junkers', 'splendid', 'neckar', 'mademsa', 'fensa', 'sindelen', 'oster', 'trotter', 'ursus', 'whirlpool', 'mabe', 'thomas', 'somela', 'toyotomi', 'marmicoc', 'tramontina', 'philips', 'bosch', 'albin', 'trotter', 'sabaf', 'eurosit', 'magefesa', 'ilko', 'teka', 'black decker', 'daewoo', 'samsung', 'lg', 'electrolux', 'midea', 'kendal', 'cerezo']);
  }
  function correct(w) {
    if (!VOCAB || VOCAB[w] || w.length < 4 || /\d/.test(w)) return w;
    var best = w, bd = w.length >= 7 ? 2 : 1;
    for (var k in VOCAB) {
      if (k[0] !== w[0] && w.length < 6) continue;
      var d = lev(w, k);
      if (d < bd || (d === bd && best === w && d <= (w.length >= 7 ? 2 : 1))) { if (d <= (w.length >= 7 ? 2 : 1)) { best = k; bd = d; } }
    }
    return best;
  }

  function detectEquip(n) {
    var e = {};
    TYPES.forEach(function (t) { if (!e.tipo && new RegExp('\\b' + t + '(es|s)?\\b').test(n)) e.tipo = t; });
    if (/calef|calentador de agua/.test(n)) e.tipo = 'calefont';
    BRANDS.forEach(function (b) { if (!e.marca && b.length > 1 && new RegExp('\\b' + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b').test(n)) e.marca = b; });
    if (!e.marca) { var tk = tokens(n); BRANDS.forEach(function (b) { if (e.marca || b.indexOf(' ') >= 0 || b.length < 5) return; tk.forEach(function (w) { if (!e.marca && w.length >= 4 && lev(w, b) <= 1) e.marca = b; }); }); }
    var m = n.match(/\b([a-z]{1,4}-?\d{1,4}[a-z]{0,3}|\d{2,4}\s?(?:l|lt|litros))\b/);
    if (m && !/^(\d+)\s?(l|lt|litros)$/.test(m[1]) ) e.modelo = m[1].replace('-', '');
    return e;
  }
  function parseQuery(text, mem) {
    var n = norm(text);
    var budget = null;
    var bm = n.match(/(hasta|menos de|maximo|bajo|presupuesto(?: de)?|no mas de|tope)\s*\$?\s*([\d\.]+)\s*(mil|k|lucas|millon(?:es)?)?/);
    if (bm) { var v = parseFloat(bm[2].replace(/\./g, '')); if (bm[3] && /mil|k|lucas/.test(bm[3])) v *= 1000; if (bm[3] && /millon/.test(bm[3])) v *= 1000000; budget = v; }
    var raw = tokens(n).filter(function (w) { return STOP.indexOf(w) < 0 && (w.length > 2 || /\d/.test(w)) && !/^\d+$/.test(w); });
    var fixed = [], corrections = [];
    raw.forEach(function (w) { var s = stem(w), c = correct(s); if (c !== s) corrections.push([w, c]); fixed.push(c); });
    var extra = [];
    SYN.forEach(function (s) { if (s[0].test(n)) extra = extra.concat(s[1]); });
    var terms = [];
    extra.concat(fixed).forEach(function (w) { if (terms.indexOf(w) < 0) terms.push(w); });
    var diag = null; DIAG.forEach(function (d) { if (!diag && d[0].test(n)) diag = d[1]; });
    return { raw: text, n: n, terms: terms.slice(0, 8), boost: extra, budget: budget, diag: diag, corrections: corrections, equip: detectEquip(n) };
  }
  function rank(pq, opts) {
    opts = opts || {};
    if (!CAT) return [];
    var res = [];
    CAT.forEach(function (x) {
      var s = 0, why = [], hits = 0;
      pq.terms.forEach(function (t) {
        var w = (CTX.indexOf(t) >= 0 ? .45 : (pq.boost || []).indexOf(t) >= 0 ? 1.6 : 1) * (IDF[t] || 1), hit = false, tt = ' ' + t;
        if (x.ti.indexOf(tt) >= 0) { s += (/\d/.test(t) ? 6 : 4) * w; hit = true; }
        else if (t.length >= 4 && x.ti.indexOf(t) >= 0) { s += 2.5 * w; hit = true; }
        if (x.me.indexOf(tt) >= 0) { s += 2 * w; hit = true; }
        if (t.length > 2 && x.vd.indexOf(t) >= 0) { s += 3; hit = true; }
        if (x.bo.indexOf(tt) >= 0) { s += .8 * w; hit = true; }
        if (hit) { hits++; if (why.length < 3) why.push(t); }
      });
      if (!hits) return;
      if (hits === pq.terms.length && hits > 1) s += 4;
      if (opts.equip) {
        if (opts.equip.marca && (x.vd.indexOf(opts.equip.marca) >= 0 || x.ti.indexOf(' ' + stem(opts.equip.marca)) >= 0)) s += 4;
        if (opts.equip.tipo && (x.ti.indexOf(' ' + opts.equip.tipo) >= 0 || x.me.indexOf(' ' + opts.equip.tipo) >= 0)) s += 2;
        if (opts.equip.modelo && x.ti.indexOf(opts.equip.modelo) >= 0) s += 5;
      }
      if (pq.budget && x.d.p > pq.budget) return;
      if (!x.d.a) s -= 2;
      res.push({ x: x.d, s: s, why: why });
    });
    res.sort(function (a, b) { return b.s - a.s || a.x.p - b.x.p; });
    var top = res.length ? res[0].s : 0;
    return res.filter(function (r) { return r.s >= Math.max(3, top * .45); }).slice(0, opts.limit || 6);
  }

  function advisor() {
    var robot = '<span class="rf-bot" aria-hidden="true">' + BOT_SVG + '</span>';
    var launch = el('button', { type: 'button', class: 'rf-adv-launch rf-chispa-launch', 'aria-expanded': 'false', 'aria-controls': 'rfAdv', 'aria-label': 'Abrir el chat con Chispa, asistente de Repuestos Feñita' },
      '<span class="rf-adv-launch__ico">' + robot + '</span><span>Chispa<small>¿Te ayudo?</small></span>');
    var panel = el('div', { id: 'rfAdv', class: 'rf-adv rf-chispa', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'rfAdvT' },
      '<div class="rf-adv__top"><span class="rf-adv__avatar">' + robot + '</span>' +
      '<div><p class="rf-adv__title" id="rfAdvT">Chispa</p><p class="rf-adv__sub"><i class="rf-dot-on"></i>Asistente de Repuestos Feñita</p></div>' +
      '<button type="button" class="rf-adv__reset" aria-label="Empezar de nuevo" title="Empezar de nuevo"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<button type="button" class="rf-adv__close" aria-label="Cerrar chat"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.2"/></svg></button></div>' +
      '<div class="rf-adv__log" aria-live="polite"></div>' +
      '<form class="rf-adv__form" autocomplete="off"><label class="rf-sr" for="rfAdvQ">Escribe tu consulta a Chispa</label>' +
      '<input id="rfAdvQ" type="text" enterkeyhint="send" placeholder="Ej: termocupla para calefont Junkers" maxlength="200">' +
      '<button type="submit" class="rf-adv__send" aria-label="Enviar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 12h15m-6-6 6 6-6 6" stroke="currentColor" stroke-width="2.4"/></svg></button></form>');
    document.body.appendChild(launch); document.body.appendChild(panel);
    var log = panel.querySelector('.rf-adv__log'), form = panel.querySelector('form'), input = panel.querySelector('input');
    var mem = LS.get('rfChispaMem') || { log: [], equip: {}, last: null, seen: 0 };
    function save() { mem.log = mem.log.slice(-40); LS.set('rfChispaMem', mem); }

    function scroll() { log.scrollTo({ top: log.scrollHeight, behavior: reduce ? 'auto' : 'smooth' }); }
    function add(cls, html, keep) {
      var m = el('div', { class: 'rf-msg ' + cls }, html); log.appendChild(m); scroll();
      if (keep !== false) { mem.log.push(['m', cls, html]); save(); }
      return m;
    }
    function chips(list, keep) {
      if (!list || !list.length) return;
      var w = el('div', { class: 'rf-chips' });
      list.slice(0, 3).forEach(function (c) {
        if (typeof c === 'string') c = { label: c };
        var b;
        if (c.href) b = el('a', { class: 'rf-chip', href: c.href, target: c.blank ? '_blank' : '_self', rel: 'noopener' }, esc(c.label));
        else { b = el('button', { type: 'button', class: 'rf-chip' }, esc(c.label)); b.addEventListener('click', function () { ask(c.q || c.label); }); }
        w.appendChild(b);
      });
      log.appendChild(w); scroll();
      if (keep !== false) { mem.log.push(['c', list.slice(0, 3)]); save(); }
    }
    function cardHTML(p, why, k) {
      var img = p.img ? p.img + (p.img.indexOf('?') > 0 ? '&' : '?') + 'width=160' : '';
      return '<div class="rf-card" style="--k:' + k + '"><a href="/products/' + esc(p.h) + '" class="rf-card__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
        '<span class="rf-card__info"><a class="rf-card__t" href="/products/' + esc(p.h) + '">' + esc(p.t) + '</a>' +
        '<span class="rf-card__p">' + CLP(p.p) + (p.c > p.p ? ' <s>' + CLP(p.c) + '</s>' : '') + (p.a ? '' : ' <em>Sin stock</em>') + '</span>' +
        (p.a && p.v ? '<button type="button" class="rf-card__add" data-v="' + p.v + '">Agregar al carrito</button>' : '') + '</span></div>';
    }
    function cards(list, keep) {
      var w = el('div', { class: 'rf-cards' }, list.map(function (r, k) { return cardHTML(r.x, r.why, k); }).join(''));
      log.appendChild(w); scroll();
      if (keep !== false) { mem.log.push(['k', list.map(function (r) { return r.x; })]); save(); }
    }
    log.addEventListener('click', function (e) {
      var b = e.target.closest('.rf-card__add'); if (!b) return;
      b.disabled = true; b.textContent = 'Agregando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-v'), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; b.textContent = 'Agregado ✓'; document.dispatchEvent(new CustomEvent('cart:refresh')); try { document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); } catch (x) {} })
        .catch(function () { b.disabled = false; b.textContent = 'Reintentar'; });
    });
    function typing() { var t = el('div', { class: 'rf-msg rf-msg--bot rf-typing', 'aria-label': 'Chispa está escribiendo' }, '<i></i><i></i><i></i>'); log.appendChild(t); scroll(); return t; }
    function equipText(e) { return [e.tipo, e.marca, e.modelo && e.modelo.toUpperCase()].filter(Boolean).join(' '); }
    function wa(text) { return 'https://wa.me/' + RF.wa + '?text=' + encodeURIComponent(text); }

    function restore() {
      mem.log.forEach(function (it) {
        if (it[0] === 'm') add(it[1], it[2], false);
        else if (it[0] === 'c') chips(it[1], false);
        else if (it[0] === 'k') cards(it[1].map(function (x) { return { x: x, why: [] }; }), false);
      });
    }
    function welcome() {
      var e = mem.equip || {};
      if (mem.seen && equipText(e)) {
        add('rf-msg--bot', '<p>¡Hola de nuevo! Soy Chispa. La última vez buscabas repuestos para tu <strong>' + esc(equipText(e)) + '</strong>. ¿Seguimos con eso?</p>');
        chips([{ label: 'Sí, ver repuestos', q: 'repuestos ' + equipText(e) }, { label: 'Buscar otra cosa', q: '__nuevo' }, { label: 'Olvidar mis datos', q: '__olvidar' }]);
      } else {
        add('rf-msg--bot', '<p>¡Hola! Soy <strong>Chispa</strong>, el asistente de Repuestos Feñita.</p><p>Cuéntame qué equipo tienes (marca y modelo si lo sabes) o qué falla tiene, y te muestro la pieza que calza. También respondo sobre envíos, retiro, pagos y boletas o facturas.</p>');
        chips(['Mi calefont se apaga', 'Quemador para cocina industrial', '¿Cuánto cuesta el envío?']);
      }
      mem.seen = (mem.seen || 0) + 1; save();
    }

    function ask(text) {
      text = String(text || '').trim(); if (!text) return;
      if (text === '__olvidar') { LS.del('rfChispaMem'); mem = { log: [], equip: {}, last: null, seen: 1 }; log.innerHTML = ''; add('rf-msg--bot', '<p>Listo, olvidé tus datos y la conversación. ¿En qué te ayudo?</p>'); chips(['Buscar un repuesto', '¿Cuánto cuesta el envío?']); return; }
      if (text === '__nuevo') { mem.equip = {}; mem.last = null; save(); add('rf-msg--bot', '<p>Perfecto. ¿Qué equipo o repuesto buscas?</p>'); input.focus(); return; }
      add('rf-msg--me', esc(text));
      var t = typing();
      var n = norm(text);
      var wait = new Promise(function (r) { setTimeout(r, reduce ? 0 : 450); });
      Promise.all([wait, loadCatalog()]).then(function () {
        t.remove();
        respond(text, n);
      });
    }

    function respond(text, n) {
      // saludos y cortesía
      if (/^(hola|buenas|buenos dias|buenas tardes|buenas noches|alo|hey)\b[\s!.]*$/.test(n)) { add('rf-msg--bot', '<p>¡Hola! ¿Qué equipo tienes o qué repuesto necesitas?</p>'); chips(['Mi calefont se apaga', 'Repuestos de licuadora', '¿Dónde están?']); return; }
      if (/^(gracias|muchas gracias|ok|listo|perfecto|genial|vale|dale)\b/.test(n)) { add('rf-msg--bot', '<p>¡De nada! Si necesitas algo más, aquí estoy.</p>'); chips(['Buscar otro repuesto', 'Hablar por WhatsApp']); return; }
      if (/hablar por whatsapp|^whatsapp$/.test(n)) { add('rf-msg--bot', '<p>Te atendemos por <a href="' + wa('Hola, vengo desde la web. ' + (equipText(mem.equip) ? 'Tengo un ' + equipText(mem.equip) + '. ' : '')) + '" target="_blank" rel="noopener">WhatsApp +56 9 3888 0493</a>.</p>'); return; }
      if (/^ver mapa$/.test(n)) { add('rf-msg--bot', '<p>Puedes ver el mapa en <a href="/pages/contact">Contacto</a>.</p>'); return; }

      // seguimientos sobre resultados anteriores
      var last = mem.last;
      if (last && last.ids && last.ids.length) {
        var lastProds = last.ids.map(function (id) { var f = CAT && CAT.find(function (c) { return c.d.i === id; }); return f && f.d; }).filter(Boolean);
        if (/mas barat|economic|menor precio|lo mas barato/.test(n) && lastProds.length) {
          var sorted = lastProds.slice().sort(function (a, b) { return a.p - b.p; });
          add('rf-msg--bot', '<p>Ordenados del más barato al más caro:</p>');
          cards(sorted.map(function (x) { return { x: x, why: [] }; }));
          chips([{ label: 'Hablar por WhatsApp' }, { label: 'Buscar otra cosa', q: '__nuevo' }]);
          return;
        }
        var ord = n.match(/\b(el |la )?(primer[oa]?|segund[oa]|tercer[oa]?|1|2|3)\b/);
        if (ord && /^(el |la )?(primer|segund|tercer|1|2|3)|cual|ese|esa|me sirve|sirve/.test(n) && lastProds.length && n.split(' ').length <= 6) {
          var idx = /segund|2/.test(ord[0]) ? 1 : /tercer|3/.test(ord[0]) ? 2 : 0;
          var p = lastProds[idx];
          if (p) { add('rf-msg--bot', '<p>' + esc(p.t) + ' cuesta <strong>' + CLP(p.p) + '</strong>' + (p.a ? ' y hay stock.' : ', pero ahora no tiene stock.') + '</p>'); cards([{ x: p, why: [] }]); chips([{ label: '¿Me sirve para mi equipo?', href: wa('Hola, ¿el producto "' + p.t + '" me sirve para mi ' + (equipText(mem.equip) || 'equipo') + '?'), blank: true }, '¿Cuánto cuesta el envío?']); return; }
        }
        if (/^(y )?(el |cual es el )?precio|cuanto (vale|cuesta|sale)$|^cuanto$/.test(n) && lastProds.length) {
          add('rf-msg--bot', '<p>' + lastProds.slice(0, 3).map(function (p) { return esc(p.t) + ': <strong>' + CLP(p.p) + '</strong>'; }).join('<br>') + '</p>');
          chips(['Ordenar del más barato', '¿Cuánto cuesta el envío?']); return;
        }
      }

      var faq = null; FAQ.forEach(function (f) { if (!faq && f.k.test(n)) faq = f; });
      var pq = parseQuery(text, mem);
      // memoria del equipo
      var e = pq.equip, had = equipText(mem.equip);
      if (e.tipo || e.marca || e.modelo) {
        if (e.tipo && mem.equip.tipo && e.tipo !== mem.equip.tipo) mem.equip = {};
        mem.equip = Object.assign({}, mem.equip, e); save();
      }
      var productish = pq.terms.length > 0 && !(faq && pq.terms.every(function (x) { return /envio|despacho|flete|region|retir|horario|pago|cuota|boleta|factura|devoluci|garantia|telefono|whatsapp|contacto|demora|llega|sucursal|direccion|tarjeta|rut/.test(x); }));
      // seguimiento corto: "¿y para el W11?" usa el equipo recordado
      if (faq && !e.tipo && !e.marca && !(pq.boost || []).length && n.split(' ').length <= 6) productish = false;
      var known = pq.terms.some(function (w) { return (VOCAB && VOCAB[w]) || /\d/.test(w); });
      if (!known) productish = productish && false;
      var useEquip = mem.equip && (pq.terms.length <= 2 || !e.tipo);
      if (productish && known && pq.terms.length <= 2 && !e.tipo && mem.lastTerms && mem.lastTerms.length && !/otra cosa|otro producto|nuevo/.test(n)) {
        mem.lastTerms.forEach(function (w) { if (pq.terms.indexOf(w) < 0 && pq.terms.length < 7) pq.terms.push(w); });
      }
      var found = productish ? rank(pq, { equip: useEquip ? mem.equip : null }) : [];
      if (!found.length && productish && useEquip && equipText(mem.equip)) {
        var pq2 = parseQuery(text + ' ' + equipText(mem.equip), mem);
        found = rank(pq2, { equip: mem.equip });
      }

      if (faq && !found.length) { add('rf-msg--bot', faq.a()); chips(faq.chips.concat(['Buscar un repuesto'])); return; }
      if (faq) add('rf-msg--bot', faq.a());
      if (pq.corrections.length) add('rf-msg--bot rf-msg--note', '<p>Entendí <em>' + pq.corrections.map(function (c) { return esc(c[1]); }).join(', ') + '</em>.</p>');
      if (pq.diag) add('rf-msg--bot', '<p><strong>Lo más probable:</strong> ' + esc(pq.diag) + '</p>');
      if (found.length) {
        mem.last = { ids: found.map(function (r) { return r.x.i; }), q: text }; mem.lastTerms = pq.terms.slice(0, 5); save();
        var et = equipText(mem.equip);
        var newEquip = et && et !== had;
        add('rf-msg--bot', '<p>' + (newEquip ? 'Anotado tu equipo: <strong>' + esc(et) + '</strong>. ' : '') + 'Estas son las opciones que mejor calzan' + (pq.budget ? ' hasta ' + CLP(pq.budget) : '') + ':</p>');
        cards(found);
        var c = [];
        if (found.length > 1) c.push({ label: 'Ordenar del más barato', q: 'más barato' });
        c.push({ label: 'Ver todos los resultados', href: '/search?q=' + encodeURIComponent(pq.terms.slice(0, 3).join(' ')) + '&type=product' });
        c.push({ label: '¿No es lo que buscas? Escríbenos', href: wa('Hola, busco: ' + text + (et ? ' (equipo: ' + et + ')' : '')), blank: true });
        chips(c);
      } else {
        add('rf-msg--bot', '<p>No encontré un producto exacto' + (equipText(mem.equip) ? ' para tu ' + esc(equipText(mem.equip)) : '') + '. Prueba con la marca y el modelo del equipo (por ejemplo <em>calefont Junkers W11</em>) o el nombre de la pieza. Si prefieres, un vendedor te ayuda por WhatsApp.</p>');
        chips([{ label: 'Preguntar por WhatsApp', href: wa('Hola, busco: ' + text + (equipText(mem.equip) ? ' (equipo: ' + equipText(mem.equip) + ')' : '')), blank: true }, { label: 'Ver repuestos', href: '/collections/repuestos' }, { label: 'Ver categorías', href: '/collections/categorias' }]);
      }
    }

    var opened = false;
    function open() {
      panel.classList.add('rf-open'); launch.setAttribute('aria-expanded', 'true');
      if (!opened) { opened = true; if (mem.log.length) restore(); welcome(); loadCatalog(); }
      setTimeout(function () { input.focus({ preventScroll: true }); }, 250);
    }
    function close() { panel.classList.remove('rf-open'); launch.setAttribute('aria-expanded', 'false'); launch.focus({ preventScroll: true }); }
    launch.addEventListener('click', open);
    panel.querySelector('.rf-adv__close').addEventListener('click', close);
    panel.querySelector('.rf-adv__reset').addEventListener('click', function () { ask('__olvidar'); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; ask(v); });
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-rf-open-advisor]');
      if (o) { e.preventDefault(); open(); }
    });
    window.RFChispa = { ask: function (q) { if (!opened) open(); ask(q); }, open: open };
  }

  /* ================= 9. Boleta o factura antes de pagar ================= */
  function rutOk(r) {
    r = String(r || '').replace(/[^0-9kK]/g, '').toUpperCase();
    if (r.length < 2) return false;
    var body = r.slice(0, -1), dv = r.slice(-1), s = 0, m = 2;
    for (var i = body.length - 1; i >= 0; i--) { s += +body[i] * m; m = m === 7 ? 2 : m + 1; }
    var res = 11 - (s % 11), exp = res === 11 ? '0' : res === 10 ? 'K' : String(res);
    return exp === dv;
  }
  function rutFmt(r) {
    r = String(r || '').replace(/[^0-9kK]/g, '').toUpperCase(); if (r.length < 2) return r;
    var body = r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return body + '-' + r.slice(-1);
  }
  function billing() {
    var saved = LS.get('rfFactura') || {};
    var modal = null, pending = null;
    function build() {
      modal = el('div', { class: 'rf-bill', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'rfBillT', hidden: '' },
        '<div class="rf-bill__box">' +
        '<button type="button" class="rf-bill__x" aria-label="Cerrar"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.2"/></svg></button>' +
        '<h2 id="rfBillT" class="rf-bill__t">¿Qué documento necesitas?</h2>' +
        '<p class="rf-bill__p">Emitimos boleta o factura electrónica por tu compra. Elige una opción para continuar al pago.</p>' +
        '<form class="rf-bill__form" novalidate>' +
        '<div class="rf-bill__opts" role="radiogroup" aria-label="Tipo de documento">' +
        '<label class="rf-bill__opt"><input type="radio" name="doc" value="Boleta" required><span><b>Boleta</b><small>Para personas</small></span></label>' +
        '<label class="rf-bill__opt"><input type="radio" name="doc" value="Factura"><span><b>Factura</b><small>Para empresas, con RUT</small></span></label>' +
        '</div>' +
        '<div class="rf-bill__fields" hidden>' +
        '<div class="rf-field"><label for="rfB1">RUT de la empresa</label><input id="rfB1" name="rut" inputmode="text" autocomplete="off" placeholder="76.123.456-7"><small class="rf-bill__err" id="rfB1e" hidden>RUT no válido. Revisa el número y el dígito verificador.</small></div>' +
        '<div class="rf-field"><label for="rfB2">Razón social</label><input id="rfB2" name="razon" autocomplete="organization"></div>' +
        '<div class="rf-field"><label for="rfB3">Giro</label><input id="rfB3" name="giro" placeholder="Ej: Restaurante"></div>' +
        '<div class="rf-field"><label for="rfB4">Dirección comercial</label><input id="rfB4" name="dir" autocomplete="street-address"></div>' +
        '<div class="rf-field"><label for="rfB5">Comuna</label><input id="rfB5" name="comuna"></div>' +
        '<div class="rf-field"><label for="rfB6">Correo para la factura</label><input id="rfB6" name="mail" type="email" autocomplete="email"></div>' +
        '</div>' +
        '<p class="rf-bill__msg" role="alert" hidden></p>' +
        '<button type="submit" class="rf-btn-red rf-bill__go">Continuar al pago</button>' +
        '</form></div>');
      document.body.appendChild(modal);
      var f = modal.querySelector('form'), fields = modal.querySelector('.rf-bill__fields'), msg = modal.querySelector('.rf-bill__msg');
      ['rut', 'razon', 'giro', 'dir', 'comuna', 'mail'].forEach(function (k) { if (saved[k]) f.elements[k].value = saved[k]; });
      f.addEventListener('change', function () {
        var fac = f.elements.doc.value === 'Factura'; fields.hidden = !fac;
        ['rut', 'razon', 'giro', 'dir', 'comuna', 'mail'].forEach(function (k) { f.elements[k].required = fac; });
      });
      f.elements.rut.addEventListener('blur', function () { if (f.elements.rut.value) f.elements.rut.value = rutFmt(f.elements.rut.value); });
      modal.querySelector('.rf-bill__x').addEventListener('click', hide);
      modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      f.addEventListener('submit', function (e) {
        e.preventDefault(); msg.hidden = true;
        var doc = f.elements.doc.value;
        if (!doc) { msg.textContent = 'Elige boleta o factura para continuar.'; msg.hidden = false; return; }
        var at = { 'Documento tributario': doc };
        if (doc === 'Factura') {
          var miss = ['rut', 'razon', 'giro', 'dir', 'comuna', 'mail'].filter(function (k) { return !f.elements[k].value.trim(); });
          var badRut = !rutOk(f.elements.rut.value);
          modal.querySelector('#rfB1e').hidden = !badRut;
          f.elements.rut.setAttribute('aria-invalid', badRut ? 'true' : 'false');
          if (miss.length || badRut) { msg.textContent = badRut ? 'El RUT no es válido.' : 'Completa todos los datos de la factura.'; msg.hidden = false; (f.elements[miss[0]] || f.elements.rut).focus(); return; }
          if (!/^\S+@\S+\.\S+$/.test(f.elements.mail.value)) { msg.textContent = 'Revisa el correo para la factura.'; msg.hidden = false; f.elements.mail.focus(); return; }
          saved = { rut: rutFmt(f.elements.rut.value), razon: f.elements.razon.value.trim(), giro: f.elements.giro.value.trim(), dir: f.elements.dir.value.trim(), comuna: f.elements.comuna.value.trim(), mail: f.elements.mail.value.trim() };
          LS.set('rfFactura', saved);
          at['Factura - RUT'] = saved.rut; at['Factura - Razón social'] = saved.razon; at['Factura - Giro'] = saved.giro;
          at['Factura - Dirección'] = saved.dir; at['Factura - Comuna'] = saved.comuna; at['Factura - Correo'] = saved.mail;
        } else {
          ['Factura - RUT', 'Factura - Razón social', 'Factura - Giro', 'Factura - Dirección', 'Factura - Comuna', 'Factura - Correo'].forEach(function (k) { at[k] = ''; });
        }
        var go = modal.querySelector('.rf-bill__go'); go.disabled = true; go.textContent = 'Guardando…';
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: at }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { go.textContent = 'Continuar al pago'; go.disabled = false; hide(); proceed(); })
          .catch(function () { go.disabled = false; go.textContent = 'Continuar al pago'; msg.textContent = 'No pudimos guardar los datos. Intenta de nuevo.'; msg.hidden = false; });
      });
    }
    function show() { if (!modal) build(); modal.hidden = false; document.documentElement.classList.add('rf-bill-open'); setTimeout(function () { var r = modal.querySelector('input[name=doc]'); r && r.focus(); }, 30); }
    function hide() { if (modal) modal.hidden = true; document.documentElement.classList.remove('rf-bill-open'); }
    function proceed() {
      if (!pending) return;
      var p = pending; pending = null;
      if (p.kind === 'buy') {
        var fd = new FormData(p.form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(function () { location.href = '/checkout'; }).catch(function () { location.href = '/cart'; });
      } else { p.btn.__rfOk = true; p.btn.click(); setTimeout(function () { if (location.pathname.indexOf('/checkout') < 0) location.href = '/checkout'; }, 1500); }
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], .shopify-payment-button__button, .shopify-payment-button button');
      if (!btn || btn.__rfOk) { if (btn) btn.__rfOk = false; return; }
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var isBuy = btn.closest('.shopify-payment-button');
      pending = isBuy ? { kind: 'buy', form: btn.closest('form') || document.querySelector('form[action*="/cart/add"]') } : { kind: 'checkout', btn: btn };
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var a = c.attributes || {};
        if (!isBuy && a['Documento tributario'] && sessionStorage.getItem('rfDocOk')) { proceed(); return; }
        try { sessionStorage.setItem('rfDocOk', '1'); } catch (x) {}
        show();
        if (modal && a['Documento tributario']) { var r = modal.querySelector('input[value="' + a['Documento tributario'] + '"]'); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
      }).catch(show);
    }, true);
    // aviso en el bloque Envíos de la ficha
    document.querySelectorAll('details.rf-ship ul, details ul').forEach(function (ul) {
      var s = ul.closest('details') && ul.closest('details').querySelector('summary');
      if (!s || !/Env[ií]os/i.test(s.textContent) || ul.querySelector('.rf-doc-li')) return;
      ul.appendChild(el('li', { class: 'rf-doc-li' }, '<strong>Boleta o factura:</strong> elige el documento antes de pagar; para factura te pedimos RUT, razón social, giro y dirección.'));
    });
  }

  /* ================= Transición entre páginas (colecciones) ================= */
  var curtain = null, leaving = false;
  function getCurtain() {
    if (!curtain) { curtain = el('div', { class: 'rf-curtain', 'aria-hidden': 'true' }); document.body.appendChild(curtain); }
    return curtain;
  }
  function isNavLink(a, e) {
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return false;
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return false;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.pathname === location.pathname && u.search === location.search) return false;
    return /^\/(collections|pages\/contact)(\/|$)/.test(u.pathname) || a.hasAttribute('data-rf-go');
  }
  function go(href, img) {
    if (leaving) return; leaving = true;
    store.set('rfEnter', 1);
    var c = getCurtain();
    if (img && !reduce) {
      var r = img.getBoundingClientRect();
      if (r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < innerHeight) {
        var f = img.cloneNode(); f.removeAttribute('srcset'); f.removeAttribute('sizes'); f.src = img.currentSrc || img.src;
        f.className = 'rf-fly'; f.removeAttribute('style');
        f.style.left = r.left + 'px'; f.style.top = r.top + 'px'; f.style.width = r.width + 'px'; f.style.height = r.height + 'px';
        document.body.appendChild(f);
        var sx = innerWidth / r.width, sy = innerHeight / r.height, s = Math.max(sx, sy);
        var tx = (innerWidth - r.width * s) / 2 - r.left, ty = (innerHeight - r.height * s) / 2 - r.top;
        f.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')', opacity: .35 }],
          { duration: 420, easing: 'cubic-bezier(.55,0,.25,1)', fill: 'forwards' });
      }
    }
    requestAnimationFrame(function () { c.classList.add('rf-on'); });
    setTimeout(function () { location.href = href; }, reduce ? 0 : 340);
  }
  function navFx() {
    if (reduce) return;
    var pf = {};
    var prefetch = function (a) { if (!isNavLink(a) || pf[a.href]) return; pf[a.href] = 1; document.head.appendChild(el('link', { rel: 'prefetch', href: a.href })); };
    document.addEventListener('pointerover', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) prefetch(a); }, { passive: true });
    document.addEventListener('touchstart', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) prefetch(a); }, { passive: true });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!isNavLink(a, e) || e.defaultPrevented) return;
      if (a.closest('.rf-hero')) return; // la portada tiene su propio movimiento de cámara
      e.preventDefault();
      var card = a.closest('product-card, .collection-card, .resource-list__item, li, article') || a;
      var img = a.querySelector('img') || (card !== a && card.querySelector('img'));
      go(a.href, img);
    });
    addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      leaving = false; if (curtain) curtain.classList.remove('rf-on');
      document.querySelectorAll('.rf-fly').forEach(function (n) { n.remove(); });
      var h = document.querySelector('.rf-hero'); if (h) h.classList.remove('rf-going');
    });
  }

  /* ================= Portada: carrusel de cocinas ================= */
  function hero() {
    var root = document.querySelector('[data-rf-hero]');
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll('[data-rf-slide]'));
    var tabs = [].slice.call(root.querySelectorAll('[data-rf-to]'));
    var idx = 0, busy = false, timer = null;
    var secs = parseInt(root.getAttribute('data-autoplay') || '8', 10);
    var auto = !reduce && secs > 0;
    root.style.setProperty('--rf-dur', secs + 's');
    if (!auto) root.classList.add('rf-noauto');

    function show(n, dir) {
      n = (n + slides.length) % slides.length;
      if (n === idx || busy) return;
      busy = true;
      var from = slides[idx], to = slides[n];
      root.classList.toggle('rf-back', dir < 0);
      root.classList.remove('rf-anim');
      to.style.transition = 'none';
      void to.offsetWidth;
      to.style.transition = '';
      root.classList.add('rf-anim');
      from.classList.add('is-leaving'); from.classList.remove('is-active'); from.setAttribute('aria-hidden', 'true');
      to.classList.add('is-active'); to.removeAttribute('aria-hidden');
      tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === n ? 'true' : 'false'); });
      idx = n;
      setTimeout(function () { from.classList.remove('is-leaving'); busy = false; }, reduce ? 0 : 920);
      restart();
    }
    function restart() {
      clearTimeout(timer);
      tabs.forEach(function (t) { var i = t.querySelector('i'); if (i) { i.style.animation = 'none'; void i.offsetWidth; i.style.animation = ''; } });
      if (auto && !root.classList.contains('rf-paused')) timer = setTimeout(function () { show(idx + 1, 1); }, secs * 1000);
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i, i > idx ? 1 : -1); }); });
    var prev = root.querySelector('[data-rf-prev]'), next = root.querySelector('[data-rf-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1, -1); });
    if (next) next.addEventListener('click', function () { show(idx + 1, 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(idx + 1, 1); } else if (e.key === 'ArrowLeft') { show(idx - 1, -1); }
    });
    var pause = function (on) { root.classList.toggle('rf-paused', on); if (on) clearTimeout(timer); else restart(); };
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(true); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') pause(false); });
    root.addEventListener('focusin', function () { pause(true); });
    root.addEventListener('focusout', function () { pause(false); });
    // deslizar con el dedo o arrastrar
    var sx = 0, sy = 0, sw = false;
    root.addEventListener('pointerdown', function (e) { if (e.target.closest('a,button')) return; sx = e.clientX; sy = e.clientY; sw = true; });
    root.addEventListener('pointerup', function (e) {
      if (!sw) return; sw = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) show(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    root.addEventListener('pointercancel', function () { sw = false; });
    // rueda/trackpad horizontal
    var wl = 0;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < 30 || Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
      var now = Date.now(); if (now - wl < 900) return; wl = now;
      show(idx + (e.deltaX > 0 ? 1 : -1), e.deltaX > 0 ? 1 : -1);
    }, { passive: true });
    new IntersectionObserver(function (es) { pause(!es[0].isIntersecting); }).observe(root);
    restart();

    // botones: la cámara avanza hacia la cocina y se abre la página siguiente
    root.querySelectorAll('a[data-rf-none]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (reduce || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0 || leaving) return;
        e.preventDefault(); leaving = true; clearTimeout(timer);
        root.classList.add('rf-going');
        store.set('rfEnter', 1);
        setTimeout(function () { getCurtain().classList.add('rf-on'); }, 380);
        setTimeout(function () { location.href = a.href; }, 640);
      });
    });
  }

  /* ================= Mapa de sucursales ================= */
  function locs() {
    document.querySelectorAll('[data-rf-locs]').forEach(function (box) {
      var tabs = box.querySelectorAll('[data-rf-map]'), frame = box.querySelector('[data-rf-iframe]'), route = box.querySelector('[data-rf-route]'), wrap = frame && frame.parentNode;
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (t.getAttribute('aria-selected') === 'true') return;
          tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
          var q = t.getAttribute('data-rf-map');
          if (wrap) wrap.classList.add('rf-swap');
          frame.src = 'https://www.google.com/maps?q=' + encodeURIComponent(q) + '&z=16&output=embed';
          frame.onload = function () { wrap.classList.remove('rf-swap'); };
          if (route) route.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(q);
        });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault(); var n = tabs[(i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); n.click();
        });
      });
    });
  }

  /* ================= Inicio ================= */
  function init() {
    try { hero3d(); } catch (e) {}
    try { reveals(); } catch (e) {}
    try { hero(); } catch (e) {}
    try { locs(); } catch (e) {}
    try { counters(); } catch (e) {}
    try { eta(); } catch (e) {}
    try { shipBlock(); } catch (e) {}
    try { advisor(); } catch (e) {}
    try { billing(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
